import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Container, Typography } from '@mui/material';

import urls from '@routes/urls';
import {
  canAccessMedicationLookupSelector,
  canAccessSupplementInquirySelector,
} from '@store/features/dashboardOrgInfo/selectors';

import InquiryList from './InquiryList/InquiryList';
import LinkCard from './LinkCard/LinkCard';
import ShareResponseModal from './ShareResponseModal/ShareResponseModal';

import './style.scss';

const InquiriesPage: FC = () => {
  const { t } = useTranslation();

  const canAccessMedicationLookup = useSelector(canAccessMedicationLookupSelector);
  const canAccessSupplementInquiry = useSelector(canAccessSupplementInquirySelector);

  return (
    <Container maxWidth="lg" className="page inquiries-page">
      <Typography variant="h1" className="inquiries-page__title">
        {t('inquiries.title')}
      </Typography>

      <div className="inquiries-page__links">
        {canAccessSupplementInquiry && (
          <LinkCard
            className="inquiries-page__link"
            title={t('inquiries.link1Title')}
            description={t('inquiries.link1Description')}
            url={urls.inquiryDraft}
          />
        )}

        {canAccessMedicationLookup && (
          <LinkCard
            className="inquiries-page__link"
            title={t('inquiries.link2Title')}
            description={t('inquiries.link2Description')}
            url={urls.medications}
          />
        )}
      </div>

      <div className="inquiries-page__content">
        <InquiryList className="inquiries-page__column" title={t('inquiries.inProgress')} />

        <InquiryList
          className="inquiries-page__column"
          title={t('inquiries.complete')}
          isComplete
        />
      </div>

      <ShareResponseModal />
    </Container>
  );
};

export default InquiriesPage;
